import styled from 'vue3-styled-components';

export const ModalContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
`;

export const DocPrintsTabArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px;
`;

export const DocPrintsTab = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  background-color: #FFD699;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  input[type="checkbox"] {
    margin-right: 8px;
  }

  &:hover {
    background-color: #FFB347;
  }

  &.active {
    background-color: #FFB347;
    font-weight: bold;
  }
`;

export const PreviewPageDiv = styled.div`
    width: 210mm;  // A4 너비
    min-height: 297mm; // A4 높이
    background-color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 1.0cm 1.0cm 1.0cm 1.0cm;
    border-radius: 10px;
    border: 1px solid #fb8b24;
    
    @media screen {
        transform: scale(0.9);
        transform-origin: top center;
        margin-bottom: -3cm; // 축소로 인한 여백 조정
    }

    @media print {
        // 프린트할 때는 원래 A4 크기로
        transform: none;
        margin: 0;
    }

    table {
        width: 100%;
        border-collapse: collapse;
    }
`;

export const DocPrintsArea = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 20px;
    
    .preview-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: calc(100% - 250px);
        overflow-x: hidden;
    }
`;

export const DocPrintsBtnArea = styled.div`
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 5px;
    margin-top: 70px;
    position: sticky;
    top: 20px;
`;

export const DocPrintsBtn = styled.div`
    display: flex;
    margin: 5px;
    padding: 5px;
    box-shadow: 0 8px 9px -4px rgba(0, 3, 8, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    background-color: #0f4c5c;
    color: #fff;

    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
  `;

export const DocPrintInput = styled.input`
  width: 15px;
  height: 15px;
`;


export const DocPrintsArrowArea = styled.div`
    position: sticky;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

export const DocPrintsArrowBtn = styled.div`
    text-align: center;
    width:50px;
    margin: 5px;
    padding: 5px;
    box-shadow: 0 8px 9px -4px rgba(0, 3, 8, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
    border-radius: 3px;

    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    } 
  `;

export const DocPrintsOptionArea = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    label{
      margin: 5px 0px;
      input{
        width: 100px;
        height:30px;
        font-weight: bold;
      }
    }
  `;

export const DocPrintsOptionTitle = styled.div`
    font-weight: bold;
    font-size: 16px;
    width: 100%;
    text-align: center;
    padding: 10px 0px;
  `;

